// types
import type { ProductLocatorItem, SidebarProps } from './Sidebar.types';

// components
import { InnerHtml } from 'components/InnerHtml/inner-html';

export function SidebarItemProduct({
  item: { name, address, zip_location: zipLocation },
}: Readonly<SidebarProps<ProductLocatorItem>>) {
  return (
    <>
      <InnerHtml as="b" content={name} />
      <InnerHtml as="div" content={address} />
      <InnerHtml as="div" content={zipLocation} />
    </>
  );
}
